export const getQueryParamValue = (url, paramName) => {
    const paramRegex = new RegExp(`[?&]${paramName}=([^&]*)`);
    const match = url.match(paramRegex);
    return match ? decodeURIComponent(match[1]) : null;
}
